export enum Status {
  Start = 'start',
  Progress = 'progress',
  End = 'end',
}

export interface ProgressData {
  name: string;
  status: Status;
  id: string | number;
  comment: string;
}

export interface ProgressEvents {
  start: (comment: string) => void;
  progress: (comment: string) => void;
  end: (comment: string) => void;
}
